import { cropsByName } from '@/services/__mocks__/cropsSeeds'
import { addDaysToDate, getCustomDate } from '@/utils/time'
import { programs } from '@/modules/execution/mock/programSeeds.js'

const defensives = [
  {
    id: 1,
    nome: 'Abacus HC',
    unidade: 'L',
    tipo: 'phytosanitary_category.diseases',
    pais_id: 1,
    is_white_mold: true,
    dose: 10,
    preco: 5,
    asset_owner_id: 1,
    unidade_medida: 'L',
    updated_at: getCustomDate(-10),
    code: '1',
    control_method_id: 1,
    created_at: getCustomDate(-10),
    numero_registro: '1',
    product_unit_measure_id: 1,
    ativo: null,
    ativo_concentracao: null,
    ativo_grupo: null,
    ativo_ingrediente: null,
    ativo_ingrediente_percent: null,
    ativo_unidade: null,
    classe: null,
    deleted_at: null,
    distribuidor_id: null,
    fcd1: null,
    fcd2: null,
    fcd3: null,
    fcd4: null,
    fcd5: null,
    fcd6: null,
    fcd7: null,
    formatacao: null,
    grupo_quimico: null,
    modo_acao: null,
    url: null,
    uso: null,
    doses: {
      soybean_asian_soybean_rust: {
        target_id: 1,
        has_register: false,
        dose_recomendada: '999999.00',
        dose_recomendada_max: '999999.00',
      },
      soybean_anthracnosis: {
        target_id: 2,
        has_register: false,
        dose_recomendada: '999999.00',
        dose_recomendada_max: '999999.00',
      },
      soybean_target_spot: {
        target_id: 3,
        has_register: true,
        dose_recomendada: 0.25,
        dose_recomendada_max: 0.3,
      },
      soybean_powdery_mildew: {
        target_id: 4,
        has_register: true,
        dose_recomendada: 0.25,
        dose_recomendada_max: 0.3,
      },
      soybean_cercospora_blight: {
        target_id: 5,
        has_register: true,
        dose_recomendada: 0.25,
        dose_recomendada_max: 0.3,
      },
      soybean_septoria_leaf_spot: {
        target_id: 11,
        has_register: true,
        dose_recomendada: 0.25,
        dose_recomendada_max: 0.3,
      },
      soybean_aerial_web_blight: {
        target_id: 12,
        has_register: false,
        dose_recomendada: '999999.00',
        dose_recomendada_max: '999999.00',
      },
      soybean_white_mold: {
        target_id: 13,
        has_register: false,
        dose_recomendada: '999999.00',
        dose_recomendada_max: '999999.00',
      },
    },
  },
  {
    id: 2,
    nome: 'Absoluto 500 SC',
    unidade: 'L',
    tipo: 'phytosanitary_category.diseases',
    pais_id: 1,
    is_white_mold: false,
    dose: 15,
    preco: 10,
    asset_owner_id: 2,
    unidade_medida: 'L',
    updated_at: getCustomDate(-9),
    code: '2',
    control_method_id: 1,
    created_at: getCustomDate(-9),
    numero_registro: '2',
    product_unit_measure_id: 2,
    ativo: null,
    ativo_concentracao: null,
    ativo_grupo: null,
    ativo_ingrediente: null,
    ativo_ingrediente_percent: null,
    ativo_unidade: null,
    classe: null,
    deleted_at: null,
    distribuidor_id: null,
    fcd1: null,
    fcd2: null,
    fcd3: null,
    fcd4: null,
    fcd5: null,
    fcd6: null,
    fcd7: null,
    formatacao: null,
    grupo_quimico: null,
    modo_acao: null,
    url: null,
    uso: null,
    doses: {
      soybean_asian_soybean_rust: {
        target_id: 1,
        has_register: false,
        dose_recomendada: '999999.00',
        dose_recomendada_max: '999999.00',
      },
      soybean_anthracnosis: {
        target_id: 2,
        has_register: false,
        dose_recomendada: '999999.00',
        dose_recomendada_max: '999999.00',
      },
      soybean_target_spot: {
        target_id: 3,
        has_register: false,
        dose_recomendada: '999999.00',
        dose_recomendada_max: '999999.00',
      },
      soybean_powdery_mildew: {
        target_id: 4,
        has_register: false,
        dose_recomendada: '999999.00',
        dose_recomendada_max: '999999.00',
      },
      soybean_cercospora_blight: {
        target_id: 5,
        has_register: false,
        dose_recomendada: '999999.00',
        dose_recomendada_max: '999999.00',
      },
      soybean_septoria_leaf_spot: {
        target_id: 11,
        has_register: true,
        dose_recomendada: 2,
        dose_recomendada_max: 3,
      },
      soybean_aerial_web_blight: {
        target_id: 12,
        has_register: false,
        dose_recomendada: '999999.00',
        dose_recomendada_max: '999999.00',
      },
      soybean_white_mold: {
        target_id: 13,
        has_register: false,
        dose_recomendada: '999999.00',
        dose_recomendada_max: '999999.00',
      },
    },
  },
  {
    id: 3,
    nome: 'Absoluto FIX',
    unidade: 'L',
    tipo: 'phytosanitary_category.diseases',
    pais_id: 1,
    is_white_mold: false,
    dose: 20,
    preco: 15,
    asset_owner_id: 3,
    unidade_medida: 'L',
    updated_at: getCustomDate(-8),
    code: '3',
    control_method_id: 3,
    created_at: getCustomDate(-8),
    numero_registro: '3',
    product_unit_measure_id: 3,
    ativo: null,
    ativo_concentracao: null,
    ativo_grupo: null,
    ativo_ingrediente: null,
    ativo_ingrediente_percent: null,
    ativo_unidade: null,
    classe: null,
    deleted_at: null,
    distribuidor_id: null,
    fcd1: null,
    fcd2: null,
    fcd3: null,
    fcd4: null,
    fcd5: null,
    fcd6: null,
    fcd7: null,
    formatacao: null,
    grupo_quimico: null,
    modo_acao: null,
    url: null,
    uso: null,
    doses: {
      soybean_asian_soybean_rust: {
        target_id: 1,
        has_register: true,
        dose_recomendada: 1.4,
        dose_recomendada_max: 1.8,
      },
      soybean_anthracnosis: {
        target_id: 2,
        has_register: false,
        dose_recomendada: '999999.00',
        dose_recomendada_max: '999999.00',
      },
      soybean_target_spot: {
        target_id: 3,
        has_register: false,
        dose_recomendada: '999999.00',
        dose_recomendada_max: '999999.00',
      },
      soybean_powdery_mildew: {
        target_id: 4,
        has_register: false,
        dose_recomendada: '999999.00',
        dose_recomendada_max: '999999.00',
      },
      soybean_cercospora_blight: {
        target_id: 5,
        has_register: false,
        dose_recomendada: '999999.00',
        dose_recomendada_max: '999999.00',
      },
      soybean_septoria_leaf_spot: {
        target_id: 11,
        has_register: true,
        dose_recomendada: 1.5,
        dose_recomendada_max: 2,
      },
      soybean_aerial_web_blight: {
        target_id: 12,
        has_register: false,
        dose_recomendada: '999999.00',
        dose_recomendada_max: '999999.00',
      },
      soybean_white_mold: {
        target_id: 13,
        has_register: false,
        dose_recomendada: '999999.00',
        dose_recomendada_max: '999999.00',
      },
    },
  },
]

const growthStages = {
  [cropsByName['soybean'].id]: [
    {
      id: 17,
      message_key: 'growth_stage.soybean.r5_1',
      name: 'R5.1',
      value: 'R5.1',
    },
    {
      id: 18,
      message_key: 'growth_stage.soybean.r5_2',
      name: 'R5.2',
      value: 'R5.2',
    },
    {
      id: 19,
      message_key: 'growth_stage.soybean.r5_3',
      name: 'R5.3',
      value: 'R5.3',
    },
    {
      id: 20,
      message_key: 'growth_stage.soybean.r5_4',
      name: 'R5.4',
      value: 'R5.4',
    },
    {
      id: 21,
      message_key: 'growth_stage.soybean.r5_5',
      name: 'R5.5',
      value: 'R5.5',
    },
    {
      id: 22,
      message_key: 'growth_stage.soybean.r6',
      name: 'R6',
      value: 'R6',
    },
    {
      id: 23,
      message_key: 'growth_stage.soybean.r7',
      name: 'R7',
      value: 'R7',
    },
    {
      id: 24,
      message_key: 'growth_stage.soybean.r8',
      name: 'R8',
      value: 'R8',
    },
    {
      id: 25,
      message_key: 'growth_stage.soybean.r9',
      name: 'R9',
      value: 'R9',
    },
  ],
}

const executions = [
  {
    aplicacao: 1,
    created_at: addDaysToDate(programs[0].data_prevista, 5),
    data_aplicacao_planejada: addDaysToDate(programs[0].data_prevista, 4),
    data_ideal: addDaysToDate(programs[0].data_prevista, 5),
    data_realizada: null,
    doenca_prioritaria_id: programs[0].doenca_prioritaria_id,
    doenca_secundaria_1_id: programs[0].doenca_secundaria_1_id,
    doenca_secundaria_2_id: programs[0].doenca_secundaria_2_id,
    doencas_sugeridas: programs[0].doencas_sugeridas,
    eficacia_ajustada: '0.00',
    eficacia_potencial: '0.00',
    eficacias: [
      {
        alvo_id: 1,
        created_at: addDaysToDate(programs[0].data_prevista, 5),
        eficacia_ajustada: 0.01,
        eficacia_potencial: 0.7913880194057584,
        eficacia_real: 0.6449163874717229,
        execucao_id: 1,
        id: 1,
        sem_registro: 1,
        severidade_id: 2,
        updated_at: addDaysToDate(programs[0].data_prevista, 5),
      },
      {
        alvo_id: 2,
        created_at: addDaysToDate(programs[0].data_prevista, 5),
        eficacia_ajustada: 0.01,
        eficacia_potencial: 0.7846937144564227,
        eficacia_real: 0.6899416148783503,
        execucao_id: 1,
        id: 2,
        sem_registro: 1,
        severidade_id: 2,
        updated_at: addDaysToDate(programs[0].data_prevista, 5),
      },
      {
        alvo_id: 3,
        created_at: addDaysToDate(programs[0].data_prevista, 5),
        eficacia_ajustada: 0.01,
        eficacia_potencial: 0.7871168811062749,
        eficacia_real: 0.6983935246149352,
        execucao_id: 1,
        id: 3,
        sem_registro: 0,
        severidade_id: 2,
        updated_at: addDaysToDate(programs[0].data_prevista, 5),
      },
      {
        alvo_id: 4,
        created_at: addDaysToDate(programs[0].data_prevista, 5),
        eficacia_ajustada: 0.01,
        eficacia_potencial: 0.7110384359623072,
        eficacia_real: 0.6122496106675043,
        execucao_id: 1,
        id: 4,
        sem_registro: 0,
        severidade_id: 1,
        updated_at: addDaysToDate(programs[0].data_prevista, 5),
      },
      {
        alvo_id: 5,
        created_at: addDaysToDate(programs[0].data_prevista, 5),
        eficacia_ajustada: 0.01,
        eficacia_potencial: 0.9106535390650781,
        eficacia_real: 0.8075196457966595,
        execucao_id: 1,
        id: 5,
        sem_registro: 0,
        severidade_id: 2,
        updated_at: addDaysToDate(programs[0].data_prevista, 5),
      },
      {
        alvo_id: 6,
        created_at: addDaysToDate(programs[0].data_prevista, 5),
        eficacia_ajustada: 0.01,
        eficacia_potencial: 0.9364435546503981,
        eficacia_real: 0.8338463972494872,
        execucao_id: 1,
        id: 6,
        sem_registro: 0,
        severidade_id: 2,
        updated_at: addDaysToDate(programs[0].data_prevista, 5),
      },
      {
        alvo_id: 7,
        created_at: addDaysToDate(programs[0].data_prevista, 5),
        eficacia_ajustada: 0.01,
        eficacia_potencial: 0.9679887459066702,
        eficacia_real: 0.8964859175603398,
        execucao_id: 1,
        id: 7,
        sem_registro: 1,
        severidade_id: 4,
        updated_at: addDaysToDate(programs[0].data_prevista, 5),
      },
      {
        alvo_id: 8,
        created_at: addDaysToDate(programs[0].data_prevista, 5),
        eficacia_ajustada: 0.01,
        eficacia_potencial: 0,
        eficacia_real: 0,
        execucao_id: 1,
        id: 8,
        sem_registro: 1,
        severidade_id: 2,
        updated_at: addDaysToDate(programs[0].data_prevista, 5),
      },
    ],
    estadio_nao_recomendado: false,
    execucao_adjuvantes: [],
    execucao_defensivos: [
      {
        created_at: addDaysToDate(programs[0].data_prevista, 5),
        defensivo: defensives[0],
        defensivo_id: defensives[0].id,
        dose: defensives[0].dose,
        execucao_id: 1,
        id: 1,
        preco: defensives[0].preco,
        updated_at: addDaysToDate(programs[0].data_prevista, 5),
      },
    ],
    id: 1,
    num_programa: 0,
    programa_id: programs[0].id,
    updated_at: addDaysToDate(programs[0].data_prevista, 5),
  },
]

export { defensives, executions, growthStages }
